import { AccountDetailsEventFlow, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackResendEmailCodeClickedPayload = TrackingPayload & {
    eventFlow: AccountDetailsEventFlow;
};

const trackResendEmailCodeClickedAnalytics = (payload: TrackResendEmailCodeClickedPayload) => {
    track(TrackingEvents.Account.ResendEmailVerificationCodeClicked, payload);
};

export const useTrackResendEmailCodeClickedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(() => {
        trackResendEmailCodeClickedAnalytics({
            eventFlow: AccountDetailsEventFlow.AccountCreation,
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [pathname, url]);
};
